import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "../telemetry";

/** Reports render errors through telemetry (T07 §9.4); never shows a stack trace to the user (T12 rule 9). */
export class ErrorBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, "react.ErrorBoundary", info.componentStack ?? undefined);
  }
  override render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
